'use strict';//Indicating browser should run only in java script mode

//*******PURPOSE: The purpose of the Directive is for displaying encounter date calendar directive while calling it.
//*******EFFECTIVE FILES: Views/HTMLTemplates/..
//*******CREATED BY: Mahesh P
//*******CREATED DATE: 08/05/2014
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
//https://github.com/g00fy-/angular-datepicker



angular.module('EMR.Admin').constant('encounterDatePickerConfig', {
	template: GetEMRPageURLByIndex_Name(76),//EMRApplicationPath + 'Home/Index/76',
	view: 'month',
	views: ['year', 'month', 'date'],
	step: 3
});

function getVisibleWeeks(date) {
	date = new Date(date || (hasValue(adminCurrentDateAndTme) ? new Date(adminCurrentDateAndTme) : new Date()));
	var startMonth = date.getMonth(), startYear = date.getYear();
	date.setDate(1);
	date.setHours(0);
	date.setMinutes(0);
	date.setSeconds(0);
	date.setMilliseconds(0);

	if (date.getDay() === 0) {
		date.setDate(-5);
	} else {
		date.setDate(date.getDate() - (date.getDay() - 1));
	}
	if (date.getDate() === 1) {
		date.setDate(-6);
	}

	var weeks = [];
	while (weeks.length < 6) {
		/*jshint -W116 */
		if (date.getYear() === startYear && date.getMonth() > startMonth) break;
		var week = [];
		for (var i = 0; i < 7; i++) {
			week.push(new Date(date));
			date.setDate(date.getDate() + 1);
		}
		weeks.push(week);
	}
	return weeks;
}

function getVisibleYears(date) {
	var years = [];
	date = new Date(date || (hasValue(adminCurrentDateAndTme) ? new Date(adminCurrentDateAndTme) : new Date()));
	date.setFullYear(date.getFullYear() - (date.getFullYear() % 10));
	for (var i = 0; i < 12; i++) {
		years.push(new Date(date.getFullYear() + (i - 1), 0, 1));
	}
	return years;
}

function getDaysOfWeek(date) {
	date = new Date(date || (hasValue(adminCurrentDateAndTme) ? new Date(adminCurrentDateAndTme) : new Date()));
	date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	date.setDate(date.getDate() - (date.getDay() - 1));
	var days = [];
	for (var i = 0; i < 7; i++) {
		days.push(new Date(date));
		date.setDate(date.getDate() + 1);
	}
	return days;
}

function getVisibleMonths(date) {
	date = new Date(date || (hasValue(adminCurrentDateAndTme) ? new Date(adminCurrentDateAndTme) : new Date()));
	var year = date.getFullYear();
	var months = [];
	for (var month = 0; month < 12; month++) {
		months.push(new Date(year, month, 1));
	}
	return months;
}




function isAfter(model, date) {
	return model && model.getTime() <= date.getTime();
}

function isBefore(model, date) {
	return model.getTime() >= date.getTime();
}

function isSameYear(model, date) {
	return model && model.getFullYear() === date.getFullYear();
}

function isSameMonth(model, date) {
	return isSameYear(model, date) && model.getMonth() === date.getMonth();
}

function isSameDay(model, date) {
	return isSameMonth(model, date) && model.getDate() === date.getDate();
}



angular.module('EMR.Admin').directive('encounterDate', ['encounterDatePickerConfig', function datePickerDirective(encounterDatePickerConfig) {

	//noinspection JSUnusedLocalSymbols
	return {
		// this is a bug ?
		template: '<div ng-include="template"></div>',
		scope: {
			model: '=encounterDate',
			after: '=?',
			before: '=?'
		},
		link: function (scope, element, attrs) {

			scope.date = new Date(scope.model || (hasValue(adminCurrentDateAndTme) ? new Date(adminCurrentDateAndTme) : new Date()));
			scope.views = encounterDatePickerConfig.views.concat();
			scope.view = attrs.view || encounterDatePickerConfig.view;
			scope.now = hasValue(adminCurrentDateAndTme) ? new Date(adminCurrentDateAndTme) : new Date();
			scope.template = attrs.template || encounterDatePickerConfig.template;

			var step = parseInt(attrs.step || encounterDatePickerConfig.step, 10);
			var partial = !!attrs.partial;

			/** @namespace attrs.minView, attrs.maxView */
			scope.views = scope.views.slice(
				scope.views.indexOf(attrs.maxView || 'year'),
				scope.views.indexOf(attrs.minView || 'date') + 1
			);

			if (scope.views.length === 1 || scope.views.indexOf(scope.view) === -1) {
				scope.view = scope.views[0];
			}

			scope.setView = function (nextView) {
				if (scope.views.indexOf(nextView) !== -1) {
					scope.view = nextView;
				}
			};

			scope.setDate = function (date) {
				if (attrs.disabled) {
					return;
				}
				scope.date = date;
				// change next view
				var nextView = scope.views[scope.views.indexOf(scope.view) + 1];
				if ((!nextView || partial) || scope.model) {

					scope.model = new Date(scope.model || date);
					var view = partial ? 'date' : scope.view;
					//noinspection FallThroughInSwitchStatementJS
					switch (view) {

						/*falls through*/
						case 'date':
							scope.model.setDate(date.getDate());
						/*falls through*/
						case 'month':
							scope.model.setMonth(date.getMonth());
						/*falls through*/
						case 'year':
							scope.model.setFullYear(date.getFullYear());
					}
					scope.$emit('setDate', scope.model, scope.view);
				}

				if (nextView) {
					scope.setView(nextView);
				}
			};

			function update() {
				var view = scope.view;
				var date = scope.date;
				switch (view) {
					case 'year':
						scope.years = getVisibleYears(date);
						break;
					case 'month':
						scope.months = getVisibleMonths(date);
						break;
					case 'date':
						scope.weekdays = scope.weekdays || getDaysOfWeek();
						scope.weeks = getVisibleWeeks(date);
						break;

				}
			}

			function watch() {
				if (scope.view !== 'date') {
					return scope.view;
				}
				return scope.model ? scope.model.getMonth() : null;
			}
			var unbindWatch = scope.$watch(watch, update);

			element.bind('encounterDate', update);

			element.on('$destroy', function () {
				element.off('encounterDate', update);//removing event
				unbindWatch();//unbinding watch
			});

			scope.next = function (delta) {
				var date = scope.date;
				delta = delta || 1;
				switch (scope.view) {
					case 'year':
					/*falls through*/
					case 'month':
						date.setFullYear(date.getFullYear() + delta);
						break;
					case 'date':
						/**
						 * If the original date is at the end of a month with more days than the target month (e.g., moving from January 31st to February),
						 *  the code correctly adjusts the date to the last day of the target month.
						 */
						let newMonth = date.getMonth() + delta;
						let newYear = date.getFullYear() + Math.floor(newMonth / 12); // Adjust year correctly
						newMonth = (newMonth % 12 + 12) % 12; // Ensure month is within 0-11 range
						date.setFullYear(newYear, newMonth, 1); // Move to the 1st of the target month
						let lastDayOfTargetMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
						date.setDate(Math.min(date.getDate(), lastDayOfTargetMonth)); // Adjust day if needed
						break;

				}
				update();
			};

			scope.prev = function (delta) {
				return scope.next(-delta || -1);
			};

			scope.isAfter = function (date) {
				return scope.after && isAfter(date, scope.after);
			};

			scope.isBefore = function (date) {
				return scope.before && isBefore(date, scope.before);
			};

			scope.isSameMonth = function (date) {
				return isSameMonth(scope.model, date);
			};

			scope.isSameYear = function (date) {
				return isSameYear(scope.model, date);
			};

			scope.isSameDay = function (date) {
				return isSameDay(scope.model, date);
			};

			scope.isNow = function (date) {
				var is = true;
				var now = scope.now;
				//noinspection FallThroughInSwitchStatementJS
				switch (scope.view) {
					/*falls through*/
					case 'date':
						is &= date.getDate() === now.getDate();
					/*falls through*/
					case 'month':
						is &= date.getMonth() === now.getMonth();
					/*falls through*/
					case 'year':
						is &= date.getFullYear() === now.getFullYear();
				}
				return is;
			};
		}
	};

}]);

